import React from 'react';
import { useSelector } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import {
  StyledEngineProvider,
  ThemeProvider as MuiV5ThemeProvider
} from '@mui/material/styles';

import useBrandData from 'bento-ordering/brand/hooks/useBrandData';
import { CHILDREN_PROP_TYPES } from 'propTypes';
import { browserHistory } from 'config/store';
import { setupTheme as createBrandTheme } from 'styles/theme/brand';
import { createDesignAndCustomizationTheme } from 'styles/theme/muiTheme';
import { getGlobalStyles } from 'styles/theme/designAndCustomization';

function BentoOrderingProviders({ children }) {
  const customizableFields = useSelector(
    state => state.account?.processed_theme_options ?? {}
  );
  const selfHostedFonts = useSelector(
    state => state.account?.selfhosted_fonts ?? []
  );
  const { hasFeature, styles, fonts } = useBrandData();

  const theme = hasFeature
    ? createBrandTheme({ styles, fonts })
    : createDesignAndCustomizationTheme({
        customizableFields,
        selfHostedFonts
      });

  const globalStyles = getGlobalStyles(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MuiV5ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles styles={globalStyles} />
        <ConnectedRouter history={browserHistory}>{children}</ConnectedRouter>
      </MuiV5ThemeProvider>
    </StyledEngineProvider>
  );
}

BentoOrderingProviders.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired
};

export default BentoOrderingProviders;
